export default "/_next/static/images/customer-shape-5445312ba975340173c1c83d587f0d40.svg";